import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { seriesModel } from '../model/index';

@Injectable()
export class SeriesService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private seriesUrl = 'api/series';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getSeriesList(query: any): Promise<seriesModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.seriesUrl}/getSeriesList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    deleteSeries(series_id: any): Promise<seriesModel> {
        const url = `${this.seriesUrl}/deleteSeries`;
        return this.http
            .post(url, $.param({ series_id: series_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as seriesModel)
            .catch(this.handleError);
    }

    addUpdateSeries(seriesData: any): Promise<seriesModel> {

        const url = `${this.seriesUrl}/addUpdateSeries`;

        return this.http
            .post(url, $.param(seriesData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as seriesModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/series.service.ts